
import { Search } from "lucide-react";
import ChatItem from "./ChatItem";

const ChatList = ({ conversations, activeConvo, onSelect, loading }) => {
  return (
    <div className="flex flex-col h-full">
      {/* Search */}
      <div className="relative mb-3 px-2">
        <Search className="absolute left-5 top-3 w-4 h-4 text-white/20" />
        <input
          placeholder="Search conversations..."
          className="w-full bg-white/5 border border-white/10 rounded-xl
            pl-10 pr-4 py-2.5 text-white text-sm outline-none
            placeholder-white/20 focus:border-white/20 transition-colors"
        />
      </div>

      {/* List */}
      <div className="flex-1 overflow-y-auto space-y-1">
        {loading ? (
          [...Array(5)].map((_, i) => (
            <div key={i} className="flex items-center gap-3 px-4 py-3">
              <div className="w-12 h-12 rounded-full bg-white/5 animate-pulse" />
              <div className="flex-1 space-y-2">
                <div className="h-3 bg-white/5 rounded animate-pulse w-1/2" />
                <div className="h-2 bg-white/5 rounded animate-pulse w-3/4" />
              </div>
            </div>
          ))
        ) : conversations.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-16 gap-2">
            <p className="text-white/20 text-sm">No conversations yet</p>
          </div>
        ) : (
          conversations.map((convo) => (
            <ChatItem
              key={convo.id}
              convo={convo}
              active={activeConvo?.id === convo.id}
              onClick={() => onSelect(convo)}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default ChatList;